/**
 * Wishlist Hero bundle price fix — lightweight on load, activates on wishlist open.
 *
 * Architecture:
 *   LOAD PHASE  — Patches JSON.parse + fetch (cheap guards); harvests button data once.
 *   ACTIVE PHASE — Starts when wishlist opens; intervals re-apply prices (paused when tab hidden).
 * Optimizations: single-pass Liquid pair output server-side; bundle API uses all_products[handle];
 *   skip deep JSON walk when root product was fully patched; WeakSet for deep traversal dedup.
 */
(function () {
  var BUNDLE_KEY = 'slk_bundle_prices';
  var WIN_KEY = '__SLIKKEPOTT_WLH_BUNDLE__';
  var _parse = JSON.parse;
  var _stringify = JSON.stringify;
  var _fetch = window.fetch;
  var _hasPrices = false;

  /* ====== Storage ====== */

  function savePrices(map) {
    try {
      localStorage.setItem(BUNDLE_KEY, _stringify(map));
      window[WIN_KEY] = Object.assign({}, map);
      window.__SLK_BUNDLE_PRICES__ = window[WIN_KEY];
      _hasPrices = true;
      _cache = null;
    } catch (e) {}
  }

  try {
    var _seed = _parse(localStorage.getItem(BUNDLE_KEY) || '{}');
    window[WIN_KEY] = Object.assign({}, _seed, window[WIN_KEY] || {}, window.__SLK_BUNDLE_PRICES__ || {});
    _hasPrices = Object.keys(window[WIN_KEY]).length > 0;
  } catch (e) {
    window[WIN_KEY] = window[WIN_KEY] || {};
  }

  var _cache = null;
  var _cacheTs = 0;

  function getBP() {
    var now = Date.now();
    if (_cache && now - _cacheTs < 800) return _cache;
    var ls = {};
    try { ls = _parse(localStorage.getItem(BUNDLE_KEY) || '{}'); } catch (e) {}
    var w = window[WIN_KEY];
    var out = (!w || typeof w !== 'object') ? ls : Object.assign({}, ls, w);
    _hasPrices = _hasPrices || Object.keys(out).length > 0;
    _cache = out;
    _cacheTs = now;
    return out;
  }

  function int(x) { var n = parseInt(x, 10); return isNaN(n) ? 0 : n; }

  /* ====== Harvest from DOM buttons ====== */

  var _lastHarvest = 0;

  function harvest() {
    var p = getBP();
    var changed = false;
    var els = document.querySelectorAll('.wishlist-hero-custom-button[data-wlh-variantid]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var vid = (el.getAttribute('data-wlh-variantid') || '').trim();
      var raw = el.getAttribute('data-wlh-price');
      if (!vid || raw == null || raw.trim() === '') continue;
      var d = parseFloat(raw.trim().replace(',', '.'));
      if (!(d > 0)) continue;
      var c = Math.round(d * 100);

      if (int(p['v:' + vid]) !== c) { p['v:' + vid] = c; changed = true; }

      var pid = el.getAttribute('data-wlh-id');
      if (pid && int(p[pid]) !== c) { p[pid] = c; changed = true; }

      var link = el.getAttribute('data-wlh-link') || '';
      var hm = link.match(/\/products\/([^/?#]+)/);
      if (hm) {
        var h = hm[1];
        if (int(p['h:' + h]) !== c) { p['h:' + h] = c; changed = true; }
        var lc = h.toLowerCase();
        if (lc !== h && int(p['h:' + lc]) !== c) { p['h:' + lc] = c; changed = true; }
      }

      var rawCmp = el.getAttribute('data-wlh-compare-price');
      if (rawCmp != null && rawCmp.trim() !== '') {
        var cd = parseFloat(rawCmp.trim().replace(',', '.'));
        if (cd > 0) {
          var cc = Math.round(cd * 100);
          if (cc > c) {
            if (int(p['cmp:v:' + vid]) !== cc) { p['cmp:v:' + vid] = cc; changed = true; }
            if (pid && int(p['cmp:' + pid]) !== cc) { p['cmp:' + pid] = cc; changed = true; }
            if (hm) {
              if (int(p['cmp:h:' + hm[1]]) !== cc) { p['cmp:h:' + hm[1]] = cc; changed = true; }
              var lcC = hm[1].toLowerCase();
              if (lcC !== hm[1] && int(p['cmp:h:' + lcC]) !== cc) { p['cmp:h:' + lcC] = cc; changed = true; }
            }
          }
        }
      }
    }
    if (changed) savePrices(p);
  }

  function maybeHarvest(force) {
    var now = Date.now();
    if (!force && now - _lastHarvest < 5000) return;
    if (!document.querySelector('.wishlist-hero-custom-button[data-wlh-variantid]')) return;
    _lastHarvest = now;
    harvest();
  }

  /* ====== Remote fetch for missing prices ====== */

  var _fetchQueued = {};

  function queueFetch(handle, variantId) {
    if (!handle || _fetchQueued[handle]) return;
    _fetchQueued[handle] = true;
    var apiPath = window.__SLIKKEPOTT_BUNDLE_API__ || '/pages/slk-bundle-cents-api';
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';
    var url = apiPath.indexOf('http') === 0
      ? apiPath + (apiPath.indexOf('?') >= 0 ? '&' : '?') + 'handle=' + encodeURIComponent(handle)
      : root + apiPath.replace(/^\//, '') + '?handle=' + encodeURIComponent(handle);
    _fetch.call(window, url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var j = null;
        var t = txt.replace(/^\uFEFF/, '').trim();
        try { j = _parse(t); } catch (e) {
          var idx = t.indexOf('{');
          if (idx >= 0) try { j = _parse(t.slice(idx)); } catch (e2) {}
        }
        if (j && j.cents > 0) {
          var p2 = getBP();
          var sc = int(j.cents);
          var cc = int(j.compare_cents);
          p2['h:' + handle] = sc;
          p2['h:' + handle.toLowerCase()] = sc;
          if (variantId) p2['v:' + variantId] = sc;
          if (cc > sc) {
            p2['cmp:h:' + handle] = cc;
            p2['cmp:h:' + handle.toLowerCase()] = cc;
            if (variantId) p2['cmp:v:' + variantId] = cc;
          } else {
            delete p2['cmp:h:' + handle];
            delete p2['cmp:h:' + handle.toLowerCase()];
            if (variantId) delete p2['cmp:v:' + variantId];
          }
          savePrices(p2);
        }
      })
      .catch(function () {})
      .finally(function () { delete _fetchQueued[handle]; });
  }

  /* ====== Price lookup helpers ====== */

  function centsForPid(bp, pid) {
    if (!pid && pid !== 0) return 0;
    var s = String(pid);
    if (bp[s]) return int(bp[s]);
    var m = s.match(/(\d+)\s*$/);
    return (m && bp[m[1]]) ? int(bp[m[1]]) : 0;
  }

  function cmpForPid(bp, pid) {
    if (!pid && pid !== 0) return 0;
    var s = String(pid);
    if (bp['cmp:' + s]) return int(bp['cmp:' + s]);
    var m = s.match(/(\d+)\s*$/);
    return (m && bp['cmp:' + m[1]]) ? int(bp['cmp:' + m[1]]) : 0;
  }

  /* ====== JSON / fetch patching ====== */

  function patchProductLike(product, cents, cmpCents) {
    cents = int(cents);
    if (!cents) return;
    cmpCents = int(cmpCents);
    var cap = cmpCents > cents ? cmpCents : null;
    product.price = cents;
    product.price_min = cents;
    product.price_max = cents;
    product.compare_at_price = cap;
    if (Array.isArray(product.variants)) {
      for (var i = 0; i < product.variants.length; i++) {
        product.variants[i].price = cents;
        product.variants[i].compare_at_price = cap;
      }
    }
  }

  /**
   * @returns {number} 2 = root Shopify product fully patched (skip patchDeep); 1 = partial; 0 = none
   */
  function patchPayload(data, bp) {
    if (!data || typeof data !== 'object') return 0;

    if (data.product && data.product.id && Array.isArray(data.product.variants)) {
      var pid = String(data.product.id);
      if (bp[pid]) { patchProductLike(data.product, bp[pid], cmpForPid(bp, pid)); return 2; }
    }

    if (data.id && Array.isArray(data.variants) && data.variants.length &&
        data.line_price === undefined && data.final_line_price === undefined) {
      var id = String(data.id);
      if (bp[id]) { patchProductLike(data, bp[id], cmpForPid(bp, id)); return 2; }
    }

    if (Array.isArray(data.products)) {
      var touched = false;
      for (var i = 0; i < data.products.length; i++) {
        var pr = data.products[i];
        if (pr && pr.id && Array.isArray(pr.variants) && bp[String(pr.id)]) {
          patchProductLike(pr, bp[String(pr.id)], cmpForPid(bp, String(pr.id)));
          touched = true;
        }
      }
      if (touched) return 1;
    }

    if (data.product_id && data.price != null && !Array.isArray(data.variants) &&
        data.inventory_management !== undefined &&
        data.line_price === undefined && data.final_line_price === undefined) {
      var pp = String(data.product_id);
      if (bp[pp]) {
        var s = int(bp[pp]);
        var cm = cmpForPid(bp, pp);
        data.price = s;
        data.compare_at_price = cm > s ? cm : null;
        return 2;
      }
    }

    return 0;
  }

  function isZeroLikePrice(v) {
    if (v === 0 || v === '0' || v === '0.0' || v === '0.00') return true;
    return typeof v === 'string' && /^0[,.]?0{0,2}$/.test(v.trim());
  }

  var _WeakSet = typeof WeakSet !== 'undefined' ? WeakSet : null;

  function patchDeep(obj, bp, depth, seenWeak, seenArr, nSeen) {
    if (!obj || typeof obj !== 'object' || depth > 8) return;
    if (nSeen.c > 200) return;
    if (_WeakSet && seenWeak) {
      if (seenWeak.has(obj)) return;
      seenWeak.add(obj);
    } else {
      if (seenArr.indexOf(obj) !== -1) return;
      seenArr.push(obj);
    }
    nSeen.c++;

    var pid = obj.shopify_product_id != null ? obj.shopify_product_id
      : obj.shopifyProductId != null ? obj.shopifyProductId
      : obj.product_id != null ? obj.product_id
      : obj.productId != null ? obj.productId : null;

    if (pid == null && typeof obj.id === 'string' && obj.id.indexOf('Product') !== -1) {
      var gm = obj.id.match(/Product\/(\d+)/i);
      if (gm) pid = gm[1];
    }

    if (pid != null) {
      var c = centsForPid(bp, pid);
      if (c) {
        var cc = cmpForPid(bp, pid);
        if ('price' in obj && (isZeroLikePrice(obj.price) || obj.price === null)) obj.price = c;
        if ('compare_at_price' in obj) obj.compare_at_price = cc > c ? cc : null;
        if ('compareAtPrice' in obj) obj.compareAtPrice = cc > c ? cc : null;
        if (obj.variant && typeof obj.variant === 'object' && isZeroLikePrice(obj.variant.price)) {
          obj.variant.price = c;
          if ('compare_at_price' in obj.variant) obj.variant.compare_at_price = cc > c ? cc : null;
        }
      }
    }

    var vid = obj.variant_id != null ? obj.variant_id : obj.variantId != null ? obj.variantId : null;
    if (vid != null) {
      var vc = bp['v:' + String(vid)];
      var vcmp = int(bp['cmp:v:' + String(vid)]);
      if (vc && 'price' in obj && (isZeroLikePrice(obj.price) || obj.price === null)) {
        var sv = int(vc);
        obj.price = sv;
        if ('compare_at_price' in obj) obj.compare_at_price = vcmp > sv ? vcmp : null;
        if ('compareAtPrice' in obj) obj.compareAtPrice = vcmp > sv ? vcmp : null;
      }
    }

    var keys = Object.keys(obj);
    var n = Math.min(keys.length, 50);
    for (var i = 0; i < n; i++) {
      var v = obj[keys[i]];
      if (v && typeof v === 'object') patchDeep(v, bp, depth + 1, seenWeak, seenArr, nSeen);
    }
  }

  function shouldInspectUrl(url) {
    if (!url || typeof url !== 'string') return false;
    var u = url.split('?')[0].toLowerCase();
    if (u.indexOf('/cart') !== -1 || u.indexOf('/checkout') !== -1 || u.indexOf('graphql.json') !== -1) return false;
    if (u.indexOf('/products') !== -1 || u.indexOf('/variants') !== -1 || u.indexOf('/recommendations/products') !== -1) return true;
    return /wishlist|wlh|wish-list|listhero|hero-wishlist|revampco|d2uzwr8l81w3zz\.cloudfront\.net/i.test(u);
  }

  function applyPatches(val, hint) {
    if (!_hasPrices || !val || typeof val !== 'object') return;
    var bp = getBP();
    if (!Object.keys(bp).length) return;
    var pr = patchPayload(val, bp);
    if (pr === 2) return;
    var h = typeof hint === 'string' ? hint : '';
    if (!h ||
        /wishlist|wlh|wishlisthero|WishList|product_id|productId|shopifyProduct|listhero|cloudfront\.net/i.test(h) ||
        /\/(products|variants)\//i.test(h) ||
        (h.indexOf('"price"') !== -1 && h.indexOf('"variants"') === -1)) {
      try {
        var ws = _WeakSet ? new _WeakSet() : null;
        patchDeep(val, bp, 0, ws, ws ? null : [], { c: 0 });
      } catch (e) {}
    }
  }

  /* --- Interceptors --- */

  JSON.parse = function (text, reviver) {
    var val = _parse.call(JSON, text, reviver);
    if (!_hasPrices) return val;
    try {
      if (typeof text !== 'string' || text.length > 2e6 || text.length < 30) return val;
      if (text.length < 500 && !/product|variant|wishlist|price|shopify/i.test(text)) return val;
      applyPatches(val, text);
    } catch (e) {}
    return val;
  };

  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : resource && resource.url ? resource.url : '';
    if (!shouldInspectUrl(url)) return _fetch.apply(this, arguments);
    return _fetch.apply(this, arguments).then(function (response) {
      if (!_hasPrices) return response;
      var ct = (response.headers && response.headers.get && response.headers.get('content-type')) || '';
      if (ct.indexOf('application/json') === -1 && url.indexOf('.js') === -1 && url.indexOf('.json') === -1) return response;
      var clone = response.clone();
      return clone.json().then(function (data) {
        applyPatches(data, url);
        return new Response(_stringify(data), {
          status: response.status, statusText: response.statusText,
          headers: { 'Content-Type': 'application/json' }
        });
      }).catch(function () { return response; });
    });
  };

  /* ====== Money formatting ====== */

  function formatMoney(cents) {
    cents = int(cents);
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    var fmt = window.__SLK_WLH_MONEY_FORMAT__ || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(re);
    if (!m) return (cents / 100).toFixed(2);
    function fd(n, p, th, de) {
      th = th || ','; de = de || '.';
      n = (n / 100.0).toFixed(p);
      var parts = n.split('.');
      var dl = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return dl + (parts[1] ? de + parts[1] : '');
    }
    var v;
    switch (m[1]) {
      case 'amount': v = fd(cents, 2); break;
      case 'amount_no_decimals': v = fd(cents, 0); break;
      case 'amount_with_comma_separator': v = fd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fd(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fd(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': v = fd(cents, 2, "'"); break;
      default: v = fd(cents, 2);
    }
    return fmt.replace(re, v);
  }

  function normText(t) {
    return String(t || '').replace(/\u00a0/g, ' ').replace(/&nbsp;/gi, ' ').trim().replace(/\s+/g, ' ');
  }

  function isZeroText(t) {
    if (!t) return false;
    var s = normText(t);
    return /^((NOK|USD|EUR|GBP|kr)\s*)?0([,.]00)?$/i.test(s) ||
           /^0([,.]00)?\s*(NOK|USD|kr)?$/i.test(s);
  }

  function centsFromLink(link, bp) {
    if (!link || !bp) return 0;
    var vm = String(link).match(/[?&]variant=(\d+)/);
    if (vm && bp['v:' + vm[1]]) return int(bp['v:' + vm[1]]);
    var pm = String(link).match(/\/products\/([^/?#]+)/);
    if (!pm) return 0;
    var hk = pm[1];
    var c = bp['h:' + hk] || 0;
    if (!c) try { c = bp['h:' + decodeURIComponent(hk)] || 0; } catch (e) { c = 0; }
    if (!c && hk.toLowerCase) c = bp['h:' + hk.toLowerCase()] || 0;
    return int(c);
  }

  function cmpFromLink(link, bp) {
    if (!link || !bp) return 0;
    var vm = String(link).match(/[?&]variant=(\d+)/);
    if (vm && bp['cmp:v:' + vm[1]]) return int(bp['cmp:v:' + vm[1]]);
    var pm = String(link).match(/\/products\/([^/?#]+)/);
    if (!pm) return 0;
    var hk = pm[1];
    var c = bp['cmp:h:' + hk] || 0;
    if (!c) try { c = bp['cmp:h:' + decodeURIComponent(hk)] || 0; } catch (e) { c = 0; }
    if (!c && hk.toLowerCase) c = bp['cmp:h:' + hk.toLowerCase()] || 0;
    return int(c);
  }

  /* ====== DOM price display ====== */

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function priceHtml(sale, cmp) {
    sale = int(sale); cmp = int(cmp);
    var st = formatMoney(sale);
    if (!cmp || cmp <= sale) return { single: true, html: esc(st), text: st };
    var ct = formatMoney(cmp);
    return {
      single: false,
      html: '<span class="slk-wlh-bundle-sale">' + esc(st) + '</span>&nbsp;&nbsp;<span class="slk-wlh-bundle-compare"><s>' + esc(ct) + '</s></span>',
      text: st + ' ' + ct
    };
  }

  function applyPriceBox(box, sale, cmp) {
    if (!box || !sale) return;
    cmp = int(cmp);
    var disp = priceHtml(sale, cmp);
    var nbsp = disp.text.indexOf(' ') !== -1 ? disp.text.replace(/ /g, '\u00a0') : disp.text;
    var span = box.querySelector('[data-wlh-item-price], span.money, .conversion-bear-money, span');
    var target = span || box;
    var bear = target.classList && target.classList.contains('conversion-bear-money');
    var cur = target.getAttribute && target.getAttribute('data-wlh-item-price');
    if (cur === nbsp && !isZeroText(target.textContent)) {
      if (disp.single) return;
      if (target.innerHTML && target.innerHTML.indexOf('slk-wlh-bundle-sale') !== -1) return;
    }
    function commit() {
      if (disp.single) {
        var good = disp.text;
        var ng = good.indexOf(' ') !== -1 ? good.replace(/ /g, '\u00a0') : good;
        if (bear) { target.innerHTML = ''; target.appendChild(document.createTextNode(ng)); }
        else { target.textContent = good; }
      } else {
        target.innerHTML = disp.html;
      }
      try { target.setAttribute('data-wlh-item-price', nbsp); } catch (e) {}
    }
    commit();
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(commit);
  }

  function fixPriceBoxes() {
    maybeHarvest(false);
    var bp = getBP();
    var boxes = document.body.querySelectorAll('.wishlist-hero-price-update, [id^="wishlist-hero-price-update-"]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var idm = (box.id || '').match(/wishlist-hero-price-update-(\d+)/);
      var vid = idm ? idm[1] : null;
      var pl = box.getAttribute('data-product-link');
      var cents = 0;
      if (vid && bp['v:' + vid]) cents = int(bp['v:' + vid]);
      if (!cents && pl) cents = centsFromLink(pl, bp);
      var cmp = 0;
      if (vid && bp['cmp:v:' + vid]) cmp = int(bp['cmp:v:' + vid]);
      if (!cmp && pl) cmp = cmpFromLink(pl, bp);
      if (!cents && pl) {
        var hm = pl.match(/\/products\/([^/?#]+)/);
        if (hm && hm[1]) queueFetch(hm[1], vid);
      }
      if (cents) applyPriceBox(box, cents, cmp);
    }
  }

  function enforceRow(row, sale, cmp) {
    if (!row || !sale) return;
    cmp = int(cmp);
    var box = row.querySelector && row.querySelector('.wishlist-hero-price-update, [id^="wishlist-hero-price-update-"]');
    if (box) { applyPriceBox(box, sale, cmp); return; }
    var disp = priceHtml(sale, cmp);
    var moneyEl = row.querySelector && row.querySelector('.money, [data-wlh-item-price], .wishlist-hero-price-update, [class*="item-price"], [class*="ItemPrice"]');
    if (moneyEl && !disp.single) { moneyEl.innerHTML = disp.html; return; }
    var good = disp.text;
    var tw = document.createTreeWalker(row, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) {
      var raw = n.textContent || '';
      if (!raw.trim()) continue;
      if (isZeroText(raw)) {
        var p = n.parentNode;
        if (p && p.nodeType === 1) {
          if (!disp.single) p.innerHTML = disp.html;
          else p.textContent = good;
        }
        return;
      }
      if (raw.indexOf(good) !== -1 || (!disp.single && raw.indexOf(formatMoney(sale)) !== -1)) return;
    }
  }

  function modalScope() {
    var card = document.querySelector('.wishlist-hero-list-card');
    if (!card) return null;
    return card.closest('.MuiDialog-root, .MuiModal-root, [role="dialog"], dialog') ||
      document.getElementById('hero-wishlist') ||
      document.querySelector('[id*="hero-wishlist"]') ||
      document.querySelector('[class*="wlh-wishlist"]') ||
      document.body;
  }

  function fixModal() {
    fixPriceBoxes();
    var bp = getBP();
    if (!Object.keys(bp).length) return;
    var root = modalScope();
    if (!root) return;

    var links = root.querySelectorAll(
      '.wishlist-hero-list-card a[href*="/products/"], a.wishlist-hero-list-card-header-product-name[href*="/products/"]'
    );
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (!m) continue;
      var hk = m[1];
      var cents = bp['h:' + hk];
      if (!cents) try { cents = bp['h:' + decodeURIComponent(hk)]; } catch (e) { cents = 0; }
      if (!cents && hk.toLowerCase) cents = bp['h:' + hk.toLowerCase()];
      if (!cents) { var vm = href.match(/[?&]variant=(\d+)/); if (vm && bp['v:' + vm[1]]) cents = int(bp['v:' + vm[1]]); }
      if (!cents) continue;
      var cmpV = bp['cmp:h:' + hk];
      if (!cmpV) try { cmpV = bp['cmp:h:' + decodeURIComponent(hk)]; } catch (e) { cmpV = 0; }
      if (!cmpV && hk.toLowerCase) cmpV = bp['cmp:h:' + hk.toLowerCase()];
      if (!cmpV) { var vm2 = href.match(/[?&]variant=(\d+)/); if (vm2 && bp['cmp:v:' + vm2[1]]) cmpV = int(bp['cmp:v:' + vm2[1]]); }
      cmpV = int(cmpV);
      var row = a.closest('.wishlist-hero-list-card, [class*="item"], [class*="row"], li, article, tr, [class*="card"], [class*="product"]') || a.parentElement;
      enforceRow(row, cents, cmpV);
    }

    var wlhIds = root.querySelectorAll('[data-wlh-id]');
    for (var j = 0; j < wlhIds.length; j++) {
      var el = wlhIds[j];
      var pid = el.getAttribute('data-wlh-id');
      if (!pid || !bp[pid]) continue;
      var cmpI = int(bp['cmp:' + pid]);
      var row2 = el.closest('li, tr, article, [class*="item"], [class*="row"]') || el.parentElement;
      enforceRow(row2, bp[pid], cmpI);
    }

    var prodIds = root.querySelectorAll('[data-product-id]');
    for (var k = 0; k < prodIds.length; k++) {
      var el2 = prodIds[k];
      var pid2 = el2.getAttribute('data-product-id');
      if (!pid2 || !bp[pid2]) continue;
      var cmpP = int(bp['cmp:' + pid2]);
      var row3 = el2.closest('[class*="item"], [class*="row"], li, article, tr') || el2.parentElement;
      enforceRow(row3, bp[pid2], cmpP);
    }
  }

  /* ====== Activation (lazy — only when wishlist UI opens) ====== */

  var _active = false;

  function burstFix() {
    maybeHarvest(true);
    try { fixModal(); } catch (e) {}
    var n = 0;
    var iv = setInterval(function () {
      try { fixModal(); } catch (e) {}
      if (++n > 20) clearInterval(iv);
    }, 350);
  }

  function activate() {
    if (_active) { burstFix(); return; }
    _active = true;
    burstFix();
    setInterval(function () {
      try {
        if (document.hidden) return;
        if (!document.querySelector('.wishlist-hero-list-card')) return;
        if (!_hasPrices) return;
        fixModal();
      } catch (e) {}
    }, 1400);
    setInterval(function () {
      try {
        if (document.hidden) return;
        if (!document.querySelector('.wishlist-hero-price-update')) return;
        fixPriceBoxes();
      } catch (e) {}
    }, 320);
  }

  document.addEventListener('wishlist-hero-wishlist-sdk-ready', activate);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(
      'a[href="#hero-wishlist"], a[href*="hero-wishlist"], .wishlist-hero-header-icon'
    );
    if (t) activate();
  });
  window.addEventListener('hashchange', function () {
    if (location.hash.indexOf('wishlist') !== -1 || location.hash === '#hero-wishlist') activate();
  });

  function onReady() {
    maybeHarvest(true);
    if (location.hash.indexOf('wishlist') !== -1 || location.hash === '#hero-wishlist') {
      activate();
    } else if (document.querySelector('.wishlist-hero-price-update, .wishlist-hero-list-card')) {
      activate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
